import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-custom-button',
    templateUrl: './custom-button.component.html',
    styleUrls: ['./custom-button.component.scss'],
    standalone: false
})
export class CustomButtonComponent {
  @Input() label: string = 'Button';
  @Input() bgColor: string = '#07073C'; // Default background color
  @Input() textColor: string = '#FFFFFF'; // Default text color
  @Input() width: string = '160px'; // Default width
  @Input() height: string = '52px'; // Default height
  @Input() disabled: boolean = false; // When true, the button is inert + muted
  @Output() clicked = new EventEmitter<void>(); // Output event for click

  onClick() {
    if (this.disabled) return; // Ignore clicks while disabled
    this.clicked.emit(); // Emit event when button is clicked
  }
}
